<template>
  <div class="home">
    <div class="container-fluid">
      <div class="text-right mb-3">
        <button class="btn btn-success" @click="executeAction('addQuoteNote', $route.params.quoteUuid)">
          <i class="fa fa-plus"></i> New Note
        </button>
      </div>
      <search-form
        :results="quoteNotes.rows"
        :total-results="quoteNotes.count"
        :options="quoteNotesForm">
      </search-form>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import {
    LOAD_QUOTE_NOTES,
    ADD_QUOTE_NOTE
  } from '@/vuex/types'
  import SearchForm from '@/components/SearchForm'

  export default {
    name: 'QuoteNoteDisplay',
    components: {
      SearchForm
    },
    computed: {
      ...mapGetters([
        'quoteNotes'
      ]),
      quoteNotesForm () {
        return {
          permalink: 'getQuoteNotes',
          method: 'post',
          params: {
            quoteUuid: this.$route.params.quoteUuid
          }
        }
      }
    },
    mounted () {
      this[LOAD_QUOTE_NOTES](this.$route.params.quoteUuid)
    },
    watch: {
      $route () {
        this[LOAD_QUOTE_NOTES](this.$route.params.quoteUuid)
      }
    },
    methods: {
      async executeAction (action, payload) {
        await this[action](payload)
      },
      ...mapActions([
        LOAD_QUOTE_NOTES,
        ADD_QUOTE_NOTE
      ])
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/admin/QuoteNoteDisplay.vue